import {
  COOLING_LABEL,
  FRAME_LABEL,
  SEGMENT_LABEL,
  TIER_LABEL,
  TIER_MAP_COLOR,
} from "../lib/tiers";
import { COOLING_MAP_COLOR, type ColorBy, FRAME_MAP_COLOR, SEGMENT_MAP_COLOR } from "./MapCanvas";

export function Legend({ colorBy }: { colorBy: ColorBy }) {
  const [colors, labels]: [Record<string, string>, Record<string, string>] =
    colorBy === "frame"
      ? [FRAME_MAP_COLOR, FRAME_LABEL]
      : colorBy === "segment"
        ? [SEGMENT_MAP_COLOR, SEGMENT_LABEL]
        : colorBy === "cooling"
          ? [COOLING_MAP_COLOR, COOLING_LABEL]
          : [TIER_MAP_COLOR, TIER_LABEL];
  return (
    <section
      className="rounded border px-2.5 py-2 text-[11px]"
      style={{
        borderColor: "var(--line-2)",
        background: "color-mix(in srgb, var(--panel) 94%, transparent)",
      }}
      aria-label="Legend"
    >
      <div className="flex flex-wrap gap-x-3 gap-y-1">
        {Object.entries(colors).map(([k, c]) => (
          <span key={k} className="flex items-center gap-1" style={{ color: "var(--muted)" }}>
            <span
              className="inline-block h-2.5 w-2.5 rounded-full"
              style={{ background: c, border: "1px solid #fff" }}
            />
            {labels[k] ?? k}
          </span>
        ))}
      </div>
      <div className="mt-1 flex items-center gap-3" style={{ color: "var(--muted-2)" }}>
        <span>Size = qualifying MW</span>
        <span className="flex items-center gap-1">
          <span
            className="inline-block h-2.5 w-2.5 rounded-full"
            style={{ border: "2px solid #c4a35a" }}
          />
          verified contact
        </span>
        <span className="flex items-center gap-1">
          <span
            className="inline-block h-2.5 w-2.5 rounded-full"
            style={{ border: "2px solid #1c1a14", background: "#7c7f76" }}
          />
          named contact
        </span>
      </div>
    </section>
  );
}
